import axios from 'axios';
import {useFormik } from 'formik';
import React, { useContext } from 'react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import step2 from '../../src/Assets/images/2.gif'
 

export default function VerfiyCode() {
   const [errorMsg, seterrorMsg] = useState()
   const [isloading , setisloading] = useState()

   const navigate = useNavigate()
     const validationSchema = yup.object({
        resetCode : yup.string().required("resetCode is not vaild"),
    
     })
  


  const {values , handleSubmit , handleChange ,errors , touched , handleBlur , isValid}= useFormik({
      initialValues:{
        resetCode :'',
      },
      onSubmit : async ()=>{
       try {
        setisloading(true)
        let response = await axios.post('https://ecommerce.routemisr.com/api/v1/auth/verifyResetCode',values)
        console.log(response.status)
        if(response.status=="200"){
        
            navigate('/reset-password')

          
        }
       } catch (error) {
        seterrorMsg(error.response.data.message)

       }
       setisloading(false)
      },

      validationSchema
     })

  return <>
   <div className="container">
   <div className='AuthDiv'>
    
    <div className="w-75 m-auto my-5 authoinner p-xl-5 p-3">
    <div className="row align-items-center">
    <div className="col-md-6">
      
    <h4>Please enter verification code that sent to your Email :</h4>
      <form onSubmit={handleSubmit}>
        
       <label htmlFor="resetCode" className='my-1'>Code:</label>
        <input onChange={handleChange} value={values.resetCode} type="text" className='form-control mb-3' id='resetCode' name='resetCode' />
        {errors.resetCode && touched.resetCode &&  <p className='alert alert-danger'>{errors.resetCode}</p>}       

   
     
       {errorMsg && <div className=" alert alert-danger">{errorMsg}</div>}
       {         isloading ? <button disabled type='button' className='btn bg-main px-3 text-white ms-auto d-block px-3'> <i className='fas fa-spin fa-spinner px-4'></i> </button>
                  :
                  <button type='submit'  className='btn bg-main px-3 text-white ms-auto d-block'>Verfiy</button>
      }

      </form>
    </div>
    <div className="col-md-6">
    <img src={step2} className='w-100'/>

    </div>

    </div>

    </div>
    </div>
   </div>
  </>
}
